export default __webpack_public_path__ + "static/media/Group9210.b3c03fa2.svg";